/**
 * Formats a date string (YYYY-MM-DD) for display without timezone shifts.
 * 
 * @param {string} dateString - Date in YYYY-MM-DD format.
 * @param {Object} options - toLocaleDateString options.
 * @returns {string} Formatted date.
 */
export const formatDate = (dateString, options = { month: 'short', day: '2-digit', year: 'numeric' }) => {
  if (!dateString) return '';
  
  // Create date object by splitting components to avoid timezone shifting
  // new Date('YYYY-MM-DD') is treated as UTC, while new Date(YYYY, MM-1, DD) is local.
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  
  return date.toLocaleDateString('en-US', options);
};

/**
 * Formats a date string for display in uppercase (standard for the app's aesthetic).
 * 
 * @param {string} dateString - Date string.
 * @returns {string} Uppercase formatted date.
 */
export const formatDisplayDate = (dateString) => {
  return formatDate(dateString).toUpperCase();
};
